import { render } from "./TranslationConfig.vue?vue&type=template&id=040fee82"
import script from "./TranslationConfig.vue?vue&type=script&lang=js"
export * from "./TranslationConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__